import { Link, useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { ASSETS } from "@/constants/assets";
import { useAuth } from "@/contexts/AuthContext";
import { useT } from "@/contexts/LanguageContext";
import LanguageSwitcher from "@/components/LanguageSwitcher";

export default function Header({ onStart }) {
  const { user, logout } = useAuth();
  const { t } = useT();
  const navigate = useNavigate();

  return (
    <motion.header
      initial={{ y: -20, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, ease: [0.22, 1, 0.36, 1] }}
      className="sticky top-0 z-40 bg-white/90 backdrop-blur-md border-b border-[#E4E7EC]"
      data-testid="site-header"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-10 flex items-center justify-between py-4 gap-4">
        <Link to="/" className="flex items-center gap-3 shrink-0 logo-on-light" data-testid="header-logo-link">
          <img
            src={ASSETS.logo}
            alt="Institut PROSPECT'HEURE"
            className="h-11 w-11 md:h-12 md:w-12 object-contain rounded-full"
          />
          <div className="leading-tight">
            <div className="font-semibold text-[15px] md:text-base text-[#0B1726] tracking-tight">
              Institut PROSPECT&rsquo;HEURE
            </div>
            <div className="text-[10px] md:text-[11px] tracking-[0.22em] text-[#667085] uppercase hidden sm:block">
              {t("header.tagline")}
            </div>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8 text-[14px] font-medium text-[#172033]">
          <a href="#livre" className="hover:text-[#9A762F] transition-colors" data-testid="nav-book">
            {t("nav.guide")}
          </a>
          <a href="#conferences" className="hover:text-[#9A762F] transition-colors" data-testid="nav-conf">
            {t("nav.conferences")}
          </a>
          <a href="#entrainement" className="hover:text-[#9A762F] transition-colors" data-testid="nav-training">
            {t("nav.training")}
          </a>
          <a href="#entraineur" className="hover:text-[#9A762F] transition-colors" data-testid="nav-coach">
            {t("nav.coach")}
          </a>
        </nav>

        <div className="flex items-center gap-2 sm:gap-3">
          <LanguageSwitcher dense />
          {user ? (
            <>
              <button
                className="hidden sm:inline text-sm font-medium text-[#172033] hover:text-[#9A762F] transition-colors"
                onClick={() => navigate("/dashboard")}
                data-testid="header-dashboard-btn"
              >
                {t("cta.myspace")}
              </button>
              <button
                className="text-xs sm:text-sm text-[#667085] hover:text-[#0B1726] transition-colors"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                data-testid="header-logout-btn"
              >
                {t("cta.logout")}
              </button>
            </>
          ) : (
            <>
              <button
                className="hidden sm:inline text-sm font-medium text-[#172033] hover:text-[#9A762F] transition-colors"
                onClick={() => navigate("/login")}
                data-testid="header-login-btn"
              >
                {t("cta.login")}
              </button>
              <button
                className="gold-btn gold-btn-pill"
                onClick={onStart}
                data-testid="header-cta-btn"
              >
                {t("cta.start")}
              </button>
            </>
          )}
        </div>
      </div>
    </motion.header>
  );
}
